<template>
  <div class="sc-header">
    <!--<img class="sc-header--img"  src="./assets/chat-logo.png" alt=""  />-->
    <img
      class="sc-header--img"
      :src="imageUrl"
      alt
      @error="useDefaultAvatar"
    >
    <div class="sc-header--title">
      <span
        class="sc-header--chatbotName"
        v-text="title"
      />
      <span
        class="sc-header--subtitle"
        v-text="subtitle"
      />
    </div>
    <div
      v-if="!isEmbedded"
      class="sc-header--close-button"
      @click="onClose"
    />
  </div>
</template>
<script>
import { serverUI } from './main'

export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    onClose: {
      type: Function,
      required: true
    },
    colors: {
      type: Object,
      required: true
    },
    cssStyle: {
      type: Object
    },
    isEmbedded: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      is_embedded: this.isEmbedded
    }
  },
  computed: {
  },
  methods: {
    useDefaultAvatar (event) {
      event.preventDefault()
      serverUI.$emit('useDefaultAvatar', true)
    }
  }
}
</script>
<style scoped>
.sc-header {
    min-height: 55px;
    border-radius: 9px 9px 0 0;
    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}

.sc-header--img {
    -ms-flex-item-align: center;
    align-self: center;
    padding: 10px 10px 10px 20px;
    width: 20%;
}

.sc-header--title {
    align-self: center;
    -webkit-box-flex: 1;
    flex: 1;
    user-select: none;
    min-width: 120px;
    font-size: 15px;
    color: #fff;
    font-size: 20px;
    font-weight: 400;
}

.sc-header--subtitle {
    font-size: small;
    display: block;
}

.sc-header--close-button {
    width: 60px;
    padding: 13px;
    box-sizing: border-box;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 15px 10px;
}

.sc-header--close-button:hover {
    box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, 0.1);
    cursor: pointer;
}

.sc-header--close-button img {
    height: 10px;
    padding-top: 20px;
}

@media (max-width: 450px) {
    .sc-header {
      /* border-radius: 0px;*/
        height: 78px;
    }
}
</style>
